import { ReactComponent } from "./check-circle-fill.svg";

interface Props {
  fill?: string;
}

const CheckCircleFillIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default CheckCircleFillIcon;
